import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SessionService } from '../../services/session/session.service';
import * as SharedActions from '../actions/shared.actions';
import { getUserSession } from '../adapters/user-session.adapter';

@Injectable()
export class SharedEffects {
  loadUserSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.loadUserSession),
      switchMap(() =>
        this.session.userData$.pipe(
          map((dashboardData) =>
            SharedActions.loadUserSessionSuccess({
              session: {
                id: 'user-session',
                userSession: getUserSession(dashboardData)
              }
            })
          ),
          catchError((error) => {
            return of(
              SharedActions.loadUserSessionFailure({
                error
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly session: SessionService
  ) {}
}
